import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { BUSINESS } from "@/lib/constants";
import { track, EVENTS } from "@/lib/analytics";

/**
 * Sticky bottom bar on mobile. Mirrors the original site CTA pairing —
 * yellow primary "Call Now" + cyan-bordered secondary "Free Estimate".
 */
export default function StickyMobileBar() {
    return (
        <div
            className="fixed bottom-0 left-0 right-0 z-30 grid grid-cols-2 lg:hidden border-t-2"
            style={{
                background: "var(--color-bg)",
                borderColor: "var(--color-line-2)",
                paddingBottom: "env(safe-area-inset-bottom)",
                boxShadow: "0 -8px 24px rgba(0,0,0,0.4)",
            }}
            data-testid="sticky-mobile-bar"
        >
            <a
                href={`tel:${BUSINESS.phoneTel}`}
                onClick={() => track(EVENTS.PHONE_CLICK, { placement: "sticky-mobile-bar" })}
                className="flex flex-col items-center justify-center gap-0.5 py-3 font-bold no-underline uppercase tracking-wider"
                style={{
                    background: "var(--color-cta)",
                    color: "var(--color-cta-ink)",
                    minHeight: 64,
                }}
                data-testid="sticky-call-btn"
            >
                <span className="inline-flex items-center gap-1.5 text-base">
                    <Phone size={18} strokeWidth={2.5} /> Call Now
                </span>
                <span className="text-[11px] font-bold tracking-wide" style={{ opacity: 0.85 }}>
                    {BUSINESS.phone}
                </span>
            </a>
            <Link
                to="/free-estimate"
                className="flex items-center justify-center gap-2 py-3 font-bold no-underline uppercase tracking-wider"
                style={{
                    background: "transparent",
                    color: "var(--color-accent)",
                    minHeight: 64,
                }}
                data-testid="sticky-estimate-btn"
            >
                Free Estimate
            </Link>
        </div>
    );
}
